import { requiredMonthlySavings } from "web_myplann/Goals/Helpers/requiredMonthlySavings";
import { RETIREMENT_CONTRIBUTION_STEP } from "web_myplann/Inspiration/Retirement/constants";

export const getRetirementRequiredContribution = (
	targetCapital: number,
	rate: number,
	months: number,
): number =>
	Math.ceil(
		requiredMonthlySavings(targetCapital, rate, months) /
			RETIREMENT_CONTRIBUTION_STEP,
	) * RETIREMENT_CONTRIBUTION_STEP;
